import URLS from '@Src/commons/ConstantUrls';
import { TypeCompanyCreation } from '@Src/components/Onboarding/OnboardingProps';
import { deleteRequestUms, getUms, postUms } from './baseService';

export const checkUniquePanAPI = (pan: string) => {
  const request = {
    url: URLS.SEARCH_IDENTIFIER,
    params: {
      docType: 'pan',
      docValue: pan,
    },
  };
  return getUms(request);
};

export const getCompanyDetailsFromGstAPI = (
  gstinNumber: string,
  userDetails = false
) => {
  const request = {
    url: URLS.FETCH_COMPANY_DETAILS,
    params: {
      identifierType: 'gstin',
      identifierValue: gstinNumber,
      userDetails,
    },
  };

  return getUms(request);
};

// create company
export const updateCompanyDetailsAPI = (data: TypeCompanyCreation) => {
  const request = {
    url: URLS.SAVE_COMPANY_DETAILS,
    data,
  };
  return postUms(request);
};

export const getVanDetailsAPI = () => {
  const request = {
    url: URLS.BILLING_DETAILS,
  };
  return getUms(request);
};

export const getUserDocsAPI = (serviceIdNo: string) => {
  const request = {
    url: URLS.FETCH_COMPANY_DOCUMENTS,
    params: {
      serviceId: serviceIdNo,
    },
  };
  return getUms(request);
};
export const removeFileActivationAPI = (uid = '') => {
  const request = {
    url: URLS.DELETE_DOCUMENT,
    data: {
      uid,
    },
  };

  return deleteRequestUms(request);
};
export const getFileUploadedDocumentStatusAPI = (fileToken = '') => {
  const request = {
    url: URLS.FILE_UPLOAD_STATUS,
    data: {
      requestToken: fileToken,
    },
  };
  return postUms(request);
};

export const submitDocuments = () => {
  const url = URLS.SUBMIT_DOCUMENT;
  return getUms({ url });
};

export const getServiceActivationDataAPI = () => {
  const url = URLS.ONBOARDING_DOC_STATUS;

  return getUms({ url });
};
